<template>
  <div class="crop-simple-container" v-if="imageUrl">
    <!-- 裁剪区域（仅显示传入的图片） -->
    <div class="crop-box">
      <img ref="cropImage" :src="imageUrl" alt="裁剪原图" />
    </div>

    <!-- 核心操作按钮（仅保留重置、确认裁剪） -->
    <div class="crop-actions">
      <!-- <button class="reset-btn" @click="resetCrop">重置裁剪框</button> -->
      <button class="confirm-btn" @click="confirmCrop">确认裁剪</button>
    </div>
  </div>
</template>

<script>
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";

export default {
  name: "CropImageSimple",
  props: {
    // 裁剪目标宽度（必传，px）
    cropWidth: {
      type: Number,
      required: true,
      validator: (val) => val > 0, // 校验：宽度必须为正数
    },
    // 裁剪目标高度（必传，px）
    cropHeight: {
      type: Number,
      required: true,
      validator: (val) => val > 0, // 校验：高度必须为正数
    },
    // 待裁剪的图片URL（必传，支持http/https/base64）
    imageUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      cropperInstance: null, // 裁剪器实例
    };
  },
  watch: {
    // 监听图片URL变化，重新初始化裁剪器
    imageUrl: {
      immediate: true, // 初始加载时触发
      handler() {
        if (this.imageUrl) {
          this.$nextTick(() => {
            this.initCropper();
          });
        }
      },
    },
  },
  methods: {
    // 初始化裁剪器（核心：按传入的宽高设置裁剪比例）
    initCropper() {
      // 销毁旧实例，避免内存泄漏
      if (this.cropperInstance) {
        this.cropperInstance.destroy();
      }

      const image = this.$refs.cropImage;
      // 计算裁剪比例 = 宽度/高度
      const aspectRatio = this.cropWidth / this.cropHeight;

      // 初始化裁剪器，强制裁剪比例匹配传入的宽高
      this.cropperInstance = new Cropper(image, {
        aspectRatio: aspectRatio, // 固定裁剪比例
        viewMode: 1, // 裁剪框限制在图片内
        dragMode: "move", // 仅允许移动图片
        cropBoxResizable: false, // 禁止调整裁剪框大小（保证输出尺寸）
        cropBoxMovable: true, // 允许移动裁剪框选择区域
        background: false, // 关闭背景网格
        autoCropArea: 1, // 初始裁剪框覆盖整张图片
      });
    },

    // 重置裁剪框到初始状态
    resetCrop() {
      if (this.cropperInstance) {
        this.cropperInstance.reset();
      }
    },

    // 确认裁剪（核心：返回指定宽高的裁剪结果）
    confirmCrop() {
      if (!this.cropperInstance) return;

      // 获取裁剪后的画布，强制输出传入的宽高
      const canvas = this.cropperInstance.getCroppedCanvas({
        width: this.cropWidth,
        height: this.cropHeight,
        imageSmoothingQuality: "high", // 高清裁剪，保证画质
      });

      // 生成两种常用格式的结果，供父组件使用
      const base64 = canvas.toDataURL("image/png"); // base64（预览用）
      canvas.toBlob((blob) => {
        // File对象（上传后端用，体积更小）
        const file = new File([blob], `crop_${Date.now()}.png`, {
          type: "image/png",
        });
        // 向父组件传递裁剪结果
        this.$emit("crop-success", {
          base64,
          blob,
          file,
          width: this.cropWidth,
          height: this.cropHeight,
        });
      }, "image/png");
    },
  },
  beforeDestroy() {
    // 组件销毁时销毁裁剪器实例，避免内存泄漏
    if (this.cropperInstance) {
      this.cropperInstance.destroy();
      this.cropperInstance = null;
    }
  },
};
</script>

<style scoped>
/* 极简样式，仅保证裁剪区域展示 */
.crop-simple-container {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  z-index: 1000;
}

/* 裁剪区域容器 */
.crop-box {
  width: 100%;
  height: 400px;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  /* border-radius: 4px; */
  /* margin-bottom: 15px; */
}

.crop-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* 操作按钮 */
.crop-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
  background-color: #ffffff;
  padding: 10px 0;
}

.reset-btn,
.confirm-btn {
  padding: 6px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  border: 1px solid #e5e5e5;
}

.confirm-btn {
  background: #1877ff;
  color: #fff;
  border-color: #1877ff;
}

.reset-btn:hover {
  border-color: #ccc;
}

.confirm-btn:hover {
  background: #0f62ff;
}
</style>



// WEBPACK FOOTER //
// src/components/CropImage/index.vue